<template>
  <div ref="PieChart" style="width: 100%; height: 100%"></div>
</template>

<script>
import * as echarts from "echarts";
import { px2rem } from "@/utils/rem";
import { generatePieChartTooltip } from "@/utils/tooltip";

export default {
  name: "PieChart",
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["finished"],
  watch: {
    data: {
      handler() {
        this.chart && this.chart.dispose();
        this.init();
      },
      deep: true,
    },
  },

  data() {
    return {
      chart: null,
      sum: 0,
    };
  },
  mounted() {
    // this.init();
  },
  methods: {
    init() {
      this.sum = this.data.reduce((total, item) => {
        return total + (item.textValue || 0);
      }, 0);
      let option = {
        color: ["#5470c6", "#91cc75", "#fac858", "#ee6666", "#73c0de"],
        tooltip: {
          show: true,
          backgroundColor: "transplant",
          borderColor: "transplant",
          borderWidth: 0,
          padding: 0,
          formatter: (params) => {
            return generatePieChartTooltip({
              name: params.name,
              value: params.value,
              percent: ((params.data.textValue / this.sum) * 100).toFixed(2),
              primaryColor: params.color,
              borderColor: params.color,
            });
          },
        },
        legend: {
          top: "5%",
          left: "center",
          // doesn't perfectly work with our tricks, disable it
          selectedMode: false,
          fontSize: px2rem(14),
          type: "scroll",
        },
        series: [
          {
            name: "Access From",
            type: "pie",
            radius: ["40%", "70%"],
            center: ["50%", "70%"],
            // adjust the start angle
            startAngle: 180,
            avoidLabelOverlap: false,
            label: {
              show: true,
              formatter: (param) => {
                // correct the percentage
                return (
                  param.name +
                  " (" +
                  ((param.data.textValue / this.sum) * 100).toFixed(2) +
                  "%)"
                );
              },
              fontSize: px2rem(14),
            },
            labelLayout: {
              hideOverlap: true,
            },
            data: this.data,
          },
        ],
      };
      this.chart = echarts.init(
        this.$refs.PieChart,
        {},
        {
          renderer: "svg",
        }
      );
      this.chart.setOption(option);
      this.chart.on("finished", () => {
        this.$emit("finished");
        this.chart.off("finished");
      });
    },
  },
  beforeDestroy() {
    // 在组件销毁前，销毁 ECharts 实例
    this.chart && this.chart.dispose();
  },
};
</script>

<style lang="scss" scoped></style>
